//---------	Global imports
import React from 'react';

//---------  Plugins
import { onTemplateLoad } from '../Components/Shared/Commons'

//---------	Translations
import { T } from '../../translations';

//---------	Components
import Banner from '../components/Banner';
import Faq from '../components/Faq';
import Newsletter from '../components/Newsletter';
import SEO from '../components/SEO/index';


class FaqTemplate extends React.Component {
  
  //---------	Constructor
  constructor() {
    super();
    
    this.state = {
      loading: true
    };
  }
  
  //---------	React functions
  componentDidMount() {
    setTimeout(() => this.setState({loading: false}), 300);
    setTimeout(() => onTemplateLoad());
  }
  
  render() {
    const data = this.props.data.markdownRemark.frontmatter;
    const seo = {
      title: `${T.SEO.title.faq} - ${data.title} | Calipsy`
    };
    
    return (
      <div className={this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper'}>
  
        <SEO {...seo}/>
        
        <div className="CalipsySpinner"></div>
        <div className="CalipsyWrapper-container">
          
          <Banner data={data.banner}/>
          
          <Faq/>
          
          <Newsletter/>
        
        </div>
      </div>
    );
  }
}

export default FaqTemplate;

export const pageQuery = graphql`
  query FaqQuery($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        title
        banner {
          imageUrl
          type
          anchor
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/faq.js